import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'nowrap',
    borderRadius: '100rem',
    marginTop: '0.25rem',
    marginRight: '8px',
    height: '36px',
    padding: '0 8px 0 12px',
    userSelect: 'none',

    '&:last-child': {
      marginRight: '0'
    }
  },

  title: {
    whiteSpace: 'nowrap',
    fontSize: theme.size.sm
  },

  icon: {
    marginLeft: '8px',
    cursor: 'pointer'
  },

  menu: {
    margin: '0 0 0 0.5rem',
    fontSize: theme.size.sm,
    color: theme.palette.textAlt
  },

  menuIcon: {
    cursor: 'pointer',
    marginLeft: '7px',
    height: 'auto',
    width: '10px',
    opacity: '0.7'
  }
}))

export default useStyles
